var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSetPinConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.688 51.063a4.5 4.5 0 110 9 4.5 4.5 0 010-9zM19.313 38.688a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm12.375 0a4.5 4.5 0 110 9 4.5 4.5 0 010-9zM19.313 26.313a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm12.375 0a4.5 4.5 0 110 9 4.5 4.5 0 010-9zM19.313 13.938a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm12.375 0a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm12.375 0a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm8.62 27.177c-.737-1.656.017-3.6 1.686-4.344 1.669-.743 3.62-.002 4.356 1.654l.707 1.484c-.737-1.655.017-3.6 1.686-4.343 1.669-.743 3.62-.003 4.356 1.653l1.103 1.861c-.738-1.656.017-3.6 1.686-4.343 1.668-.743 3.619-.003 4.356 1.654l2.265 5.087m-22.169-.13l-5.541-12.444a3.263 3.263 0 00-1.829-1.726 3.318 3.318 0 00-2.527.073 3.315 3.315 0 00-1.745 1.829 3.27 3.27 0 00.059 2.514l7.883 17.708s1.717 3.199.964 7.12m24.905-14.944s9.546 15.778-5.094 24.8c0 0-6.737 4.802-15.642.658 0 0-3.818-.523-7.439-4.684 0 0-1.624-3.26-6.142-6.149 0 0-3.365-2.111-1.338-4.288 0 0 2.187-3.097 5.129-1.292 0 0 3.104 1.404 5.812 3.726m7.365 14.183l3.97 9.14s12.498 3.495 19.401-8.189l-4.189-9.295",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.778 82.116c-.032.025-.082-.037-.107-.068-.128-4.734.087-9.49.722-14.173.006-.056.037-.081.068-.106 1.76-.242 3.415-.295 5.078-.149.312.004.539.284.534.597l-.674 8.575c-.005.056.02.087.076.093 2.45.229 5.938.595 8.388.825.057.005.082.037.076.093l-.719 5.214c-.006.056-.037.082-.093.076-.506-.054-9.807-.86-13.35-.977z",
    fill: "#FF94CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.461 8.616c.028-.02.068.036.089.064-.092 4.074-.478 8.15-1.222 12.144-.006.049-.034.069-.062.09a19.23 19.23 0 01-4.362-.115c-.268-.018-.45-.27-.434-.537l.942-7.34c.008-.047-.013-.075-.06-.083-2.093-.313-5.07-.794-7.162-1.108-.049-.007-.07-.035-.06-.083l.837-4.446c.006-.049.035-.07.083-.061.432.07 8.377 1.205 11.412 1.474z",
    fill: "#006AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 19,
    r: 3,
    fill: "#FF94CA",
    fillRule: "nonzero",
    transform: "rotate(-180 75 19)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSetPinConfetti);
export default __webpack_public_path__ + "static/media/icon-set-pin-confetti.cf1a933a.svg";
export { ForwardRef as ReactComponent };